/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_Existing_DescInputs */

const en_plan_choose_existing_desc = /** @type {(inputs: Plan_Choose_Existing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a repo to build a PRD and a project map.`)
};

const id_plan_choose_existing_desc = /** @type {(inputs: Plan_Choose_Existing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sambungkan repo untuk membuat PRD dan peta proyek.`)
};

/**
* | output |
* | --- |
* | "Connect a repo to build a PRD and a project map." |
*
* @param {Plan_Choose_Existing_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_existing_desc = /** @type {((inputs?: Plan_Choose_Existing_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_Existing_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_existing_desc(inputs)
	return en_plan_choose_existing_desc(inputs)
});